import BaseComponent from '../base/baseComponent';
export default class ProductCarouselComponent extends BaseComponent {
    constructor(element) {
        super(element);
        this.listenerIsOn = false;
        this.init();
    }
    get Messages() {
        return {
            [this.CUSTOM_MESSAGES.BREAKPOINTER.BREAKPOINT_CHANGE]: this.onBreakpointChange,
        };
    }
    init() {
        this.$el.addEventListener('submit', this.onFormSubmit);
        if (window.isMobile()) {
            this.$el.addEventListener('change', this.onSelectChange);
            this.listenerIsOn = true;
        }
    }
    onSelectChange(e) {
        e.preventDefault();
        let formData = new FormData(e.currentTarget);
        window.location.href = e.currentTarget.action + formData.get('faqCategory');
    }
    onFormSubmit(e) {
        e.preventDefault();
        let formData = new FormData(e.target);
        window.location.href = e.target.action + formData.get('faqCategory');
    }
    onBreakpointChange(br) {
        if (br.value >= window.mqObj['sm'] && this.listenerIsOn) {
            this.$el.removeEventListener('change', this.onSelectChange);
            this.listenerIsOn = false;
        }
        else if (br.value < window.mqObj['md'] && !this.listenerIsOn) {
            this.$el.addEventListener('change', this.onSelectChange);
            this.listenerIsOn = true;
        }
    }
}
